'use strict';
'use client';
import { j as r } from "../../external/react/jsx-runtime.js";
import { createContext as s, useContext as h } from "react";
const t = s({});
function m({ theme: e, children: o }) {
  return /* @__PURE__ */ r.jsx(t.Provider, { value: { theme: e }, children: o });
}
function u() {
  const e = h(t);
  if (e === void 0)
    throw new Error("useTheme must be used within a SharedProvider");
  return {
    isMosh: e.theme === "mosh",
    isMoshy: e.theme === "moshy",
    theme: e.theme
  };
}
export {
  m as SharedProvider,
  u as useTheme
};
